exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sku-select[data-v-41687a81]  .el-form-item.is-error .el-input__inner{border-color:#dddfe7 !important}.sku-select .selWidth[data-v-41687a81]{width:200px}", ""]);

// exports
